import { Component } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { EntityListAction, Permission } from "projects/sepidz-web-framework/src/lib/models";
import { takeUntil } from "rxjs/operators";
import { GoodsGroupFormComponent } from "../goods-group-form/goods-group-form.component";
import { GoodsGroupImportExportFormComponent } from "../goods-group-import-export/goods-group-import-export-form.component";

@Component({
  selector: "ngx-goods-group-list",
  templateUrl: "./goods-group-list.component.html",
  styleUrls: ["./goods-group-list.component.scss"],
})
export class GoodsGroupListComponent extends BaseListComponent {
  constructor() {
    super();
    this.inputEditorform = GoodsGroupFormComponent;
    this.onActionClick = this.onActionClick.bind(this);
  }
  ngOnInit() {
    this.apiName = "GoodsGroup";
    this.areaName = "Inventory";
    this.label = this.translate("ClientApp.BackOffice.INV.GoodsGroup.GoodsGroup");
    this.setactions();
  }
  setactions() {
    this.actions = [
      {
        name: "ImportExport",
        disabled: false,
        displayName: "استخراج و دریافت",
        iconName: "icon-import_export-o",
        apiName: "GoodsGroup/ImportExport",
        areaName: "Inventory",
        Form_Component: GoodsGroupImportExportFormComponent,
        permission: Permission.samePermission,
      },
    ];
  }
  onActionClick(action: EntityListAction) {
    if (action.name === "ImportExport") {
      this.dialogService
        .open(
          action.Form_Component,
          {
            label: action.displayName,
          },
          {
            autoFocus: true,
            closeOnClickOutside: false,
          }
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((model) => {});
    }
  }
}
